import React, { useState, useEffect, useRef } from 'react';
import Rules from './Rules';
import Justly from './Justly';
import { PageView } from './classes/PageView';
import { Pages } from './constants/Pages';
import Footer from './Footer';
import Header from './Header';
import Menu from './Menu';
import Reviews from './Reviews';
import UpcomingEvents from './UpcomingEvents';

function Home() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        PageView.addNewPageView(Pages.Home);
    }, [])

    useEffect(() => {
        function handleClickOutside(e: MouseEvent) {
            if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
                setIsMenuOpen(false);
            }
        }

        if (isMenuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isMenuOpen]);

    return (
        <div className="home">
            {isMenuOpen && <Menu ref={menuRef} />}
            <Header setIsMenuOpen={setIsMenuOpen} />
            <Justly />
            <Rules />
            <Reviews />
            <UpcomingEvents />
            <Footer />
        </div>
    );
}

export default Home;
